const runtimeConfig = typeof window !== 'undefined' ? window.__CMS_CONFIG__ || {} : {};

export const region = runtimeConfig.region || import.meta.env.VITE_AWS_REGION || import.meta.env.VITE_REGION || 'us-east-1';
export const userPoolId = runtimeConfig.userPoolId || import.meta.env.VITE_USER_POOL_ID || '';
export const clientId = runtimeConfig.clientId || import.meta.env.VITE_USER_POOL_CLIENT_ID || '';
export const apiEndpoint = runtimeConfig.apiEndpoint || import.meta.env.VITE_API_ENDPOINT || '';
export const graphqlEndpoint = runtimeConfig.graphqlEndpoint || import.meta.env.VITE_GRAPHQL_ENDPOINT || '';
export const graphqlWsEndpoint = runtimeConfig.graphqlWsEndpoint || import.meta.env.VITE_GRAPHQL_WS_ENDPOINT || '';

const config = {
  region,
  userPoolId,
  clientId,
  apiEndpoint,
  graphqlEndpoint,
  graphqlWsEndpoint,
};

export default config;
